import { render, staticRenderFns } from "./Analysis.vue?vue&type=template&id=07bbca96&scoped=true&"
var script = {}
import style0 from "./Analysis.vue?vue&type=style&index=0&id=07bbca96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bbca96",
  null
  
)

export default component.exports